<div class="text-left overflow-auto" *ngIf="!bResetting"
    [ngStyle]="{maxHeight: 'calc(100vh - ' + 310 + 'px)'}">

    <accordion [closeOthers]="true" [isAnimated]="true">
        <ng-container *ngFor="let e of errorEvents | reverse">
            <accordion-group [isOpen]="e.error && (!errorEvent || errorEvent==e)">
            <div accordion-heading class="mx-1 text-danger font-weight-bold font-italic">
                <div class="d-flex flex-row justify-content-between">
                    <div>
                        <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
                        {{e.message|shorten:250:'...'}}        
                    </div>
                    <div role="button" class="m-0 px-1 py-0 text-secondary" style="position:absolute;top:0;right:0;"
                        (click)="removeError(e)">
                        &times;
                    </div>
                </div>
            </div>
            <div *ngIf="e.error" [ngStyle]="{maxHeight: 'calc(100vh - ' + (310+errorEvents.length*48) + 'px)'}">
                <pre class="mb-0 overflow-auto"
                ><ng-container *ngIf="e.error?.stack; else objError"
                >{{e.error.message}}<br><br>{{e.error.stack}}</ng-container
                ><ng-template #objError>{{e.error|json}}<br><ng-container *ngIf="e.stack"
                ><br>{{e.stack}}</ng-container></ng-template></pre>
            </div>
            </accordion-group>
        </ng-container>
    </accordion>

</div> 
